import React, { useContext } from 'react';
import { ContextServiceDesk } from '../../contexts/ServiceDeskContext';
import SendedFormIcon from '../SendedFormIcon';
import useTranslate from '../../customHooks/useTranslate';
import Card from '../../muiComponents/Card';

const ServiceDeskStep4 = () => {
    const { inputsData } = useContext(ContextServiceDesk);
    const { Code } = inputsData;

    return (
        <div className='step-content__container'>
            <Card className='sended-form__container'>
                <SendedFormIcon />
                <div>
                    <h3 className='sended-form__title'>
                        {useTranslate('thank_you_support_ticket')}
                    </h3>
                    <p className=''>{useTranslate('we_will_check')}</p>
                    <p className=''>
                        {`${useTranslate('reference_number')}`}
                        <span className='font-weight-b'>{Code}</span>
                    </p>
                </div>
            </Card>
        </div>
    );
};

export default ServiceDeskStep4;
